import { useAuth } from 'contexts/AuthContext'

const withAuth = Component => {
  return props => {
    const auth = useAuth()
    return <Component {...props} auth={auth} />
  }
}

export default withAuth
